import './slider/frontend.js';
import './accordion/frontend.js';
import './modal/frontend.js';